module.exports = __webpack_public_path__ + "img/TRACTOR.f917cb59.svg";